import { React, useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../assets/fulllogo.jpg";

const Header = () => {
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleScroll = () => {
    if (window.scrollY > 50) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`text-[#fcc11b] top-0 left-0 right-0 fixed z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#000000] bg-opacity-90 shadow-md" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center">
          <img
            src={logo}
            alt="Supreme Detail Wa Logo"
            className="h-12 w-12 mr-2 rounded-none"
          />
          <span className="text-2xl font-bold drop-shadow-md sm:text-3xl">
            Fixit Handyman Home Services LLC
          </span>
        </Link>
        <nav className="hidden md:flex space-x-4 sm:text-lg font-bold">
          <Link
            to="/"
            className={`hover:underline ${
              location.pathname === "/" && "underline drop-shadow-md"
            }`}
            style={{
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              color: "#fcc11b",
            }}
          >
            Home
          </Link>
          <Link
            to="/services"
            className={`hover:underline ${
              location.pathname === "/services" && "underline drop-shadow-md"
            }`}
            style={{
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              color: "#fcc11b",
            }}
          >
            Services
          </Link>
          <Link
            to="/gallery"
            className={`hover:underline ${
              location.pathname === "/gallery" && "underline drop-shadow-md"
            }`}
            style={{
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              color: "#fcc11b",
            }}
          >
            Finished Projects
          </Link>
          <Link
            to="/contact"
            className={`hover:underline ${
              location.pathname === "/contact" && "underline drop-shadow-md"
            }`}
            style={{
              textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              color: "#fcc11b",
            }}
          >
            Contact
          </Link>
        </nav>
        <button className="md:hidden" onClick={toggleDrawer}>
          <FaBars />
        </button>
      </div>
      {drawerOpen && (
        <div className="fixed inset-0 backdrop-blur-md z-50 md:hidden">
          <div className="absolute top-0 right-0 p-4">
            <button onClick={toggleDrawer}>
              <FaTimes className="text-[#fcc11b]" />
            </button>
          </div>
          <div className="flex flex-col items-center justify-center h-1/3 my-20 space-y-4 text-[#fcc11b] p-4 max-w-xs mx-auto bg-black rounded-lg shadow-lg">
            <Link
              to="/"
              onClick={toggleDrawer}
              className={`text-xl ${location.pathname === "/" && "underline"}`}
              style={{
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                color: "#fcc11b",
              }}
            >
              Home
            </Link>
            <Link
              to="/services"
              onClick={toggleDrawer}
              className={`text-xl ${
                location.pathname === "/services" && "underline"
              }`}
              style={{
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                color: "#fcc11b",
              }}
            >
              Services
            </Link>
            <Link
              to="/gallery"
              onClick={toggleDrawer}
              className={`text-xl ${
                location.pathname === "/gallery" && "underline"
              }`}
              style={{
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                color: "#fcc11b",
              }}
            >
              Finished Projects
            </Link>
            <Link
              to="/contact"
              onClick={toggleDrawer}
              className={`text-xl ${
                location.pathname === "/contact" && "underline"
              }`}
              style={{
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
                color: "#fcc11b",
              }}
            >
              Contact
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
